import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const VERSION = 0;
const URL = API_URL + "/saas/multi-tenancy/connection-uri-domain";

export async function removeMultiTenancyApp(data: { deploymentId?: string }): Promise<void> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000,
        params: {
            deploymentId: data.deploymentId
        }
    };

    await httpNetworking.simpleDELETERequest(URL, options, VERSION);
}
